
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as debug2MH7X4CfQRx1h_45ta1ByuPeCmzWA8eiYHBWQGpxbKRL8Meta } from "/src/pages/debug.vue?macro=true";
import { default as indexL2_4506P0VKVzlQLJwGht__tlSHUjvBBZYAsDJVWgdCGIMeta } from "/src/packages/commerce/pages/index.vue?macro=true";
import { default as index1GLApJohVvBayp7Ny7TMLSZlXDigQQKeoJr_45YOC9Q8cMeta } from "/src/pages/p/index.vue?macro=true";
import { default as wartungfMwduimPPGp50NC2aGowLppV3eJw81Ydo9B3olbgNVsMeta } from "/src/pages/wartung.vue?macro=true";
import { default as indexJl1Ft0yZCanmCN8pZVI8mPovWSGnz9kFwGfaeyzthFEMeta } from "/src/packages/manage-job-ads/pages/p/jobs/index.vue?macro=true";
import { default as createNe4jlXPQawOgHQAz0ktoMzkSr5rzhmW_45x8p4SwA4iLAMeta } from "/src/packages/manage-job-ads/pages/p/jobs/create.vue?macro=true";
import { default as smart_45bewerbenw_K19F2MTfsc6viFKM95kVeX3oMuaUivEOyLtL7LLREMeta } from "/src/packages/commerce/pages/smart-bewerben.vue?macro=true";
import { default as linkBWj1BywM3RTeTTUG6x_45GYmsTQh1e4bgcdkBkpCQWOo4Meta } from "/src/packages/base/pages/styleguide/link.vue?macro=true";
import { default as pillL_TRW_Z2_45hM_rk4JUN8B73rGK70Z4YyZa9hxkzFMcG0Meta } from "/src/packages/base/pages/styleguide/pill.vue?macro=true";
import { default as tabsJM1NrDc5e7wqd5MaCk2HmIWJ4qOOUjvp4phL3O2WlMwMeta } from "/src/packages/base/pages/styleguide/tabs.vue?macro=true";
import { default as bewerber_45manageroMaMQKykdRAtHV5TgyY9wBWU572YiOuVu1Hlwo4HVgQMeta } from "/src/packages/commerce/pages/bewerber-manager.vue?macro=true";
import { default as indexLlCzd8rU7RMn7qG3MtPhJ9jCiQyjQ2sBqiC37gQRjfsMeta } from "/src/packages/manage-job-ads/pages/p/internal/index.vue?macro=true";
import { default as login0TsUJJE1oGh8vVkt7wPELZPYfAq2HPTAvM2SS0SfyfoMeta } from "/src/packages/manage-job-ads/pages/p/internal/login.vue?macro=true";
import { default as dataFpSoOm858ehsByck4V4dcnf_dH1DopEiNSv5_CMBqAgMeta } from "/src/packages/manage-job-ads/pages/p/jobs/[id]/data.vue?macro=true";
import { default as groupTiOhuOFLkqlAVtvyQ4FWN_yp4ge64mGd48a3Comb0ZgMeta } from "/src/packages/base/pages/styleguide/group.vue?macro=true";
import { default as index4lsU2BrKCyQvJJL6VgbRSlgeoyUJIyStpZairOQ9fCoMeta } from "/src/packages/base/pages/styleguide/index.vue?macro=true";
import { default as modalAgh5ioxmfmDqcNq8eJO51WRzA3G4JIhmrrKs7rb6YT4Meta } from "/src/packages/base/pages/styleguide/modal.vue?macro=true";
import { default as tableR_lukLHoWFxZNjg0H2Hg0HwDBFU95BQLRsg4dkUa6J4Meta } from "/src/packages/base/pages/styleguide/table.vue?macro=true";
import { default as indexGqBNXcbUksxiJB_45T1I355fZbES18WjhFZbvFRqSLpYcMeta } from "/src/packages/manage-talents/pages/p/active-sourcing/search/index.vue?macro=true";
import { default as indexGhJjUyEyuX6TTfNfAECT9B8O9hvIGFRWxtWZrNuQKCMMeta } from "/src/packages/manage-talents/pages/p/active-sourcing/matching/index.vue?macro=true";
import { default as index8GaCZgXZ_S3o1AOf2brXTcIt0wnDLj43lIOE7hgFuCYMeta } from "/src/packages/manage-talents/pages/p/active-sourcing/messages/index.vue?macro=true";
import { default as indexDOJMelVLys_cLXkc5nisuu5kD2c9SP7ZXT_vYeqwYV0Meta } from "/src/packages/manage-talents/pages/p/active-sourcing/projects/index.vue?macro=true";
import { default as indexpJMLX1SN4z0B3MogXlucTYUR_45ndO5HrOZ6pHOaqG_woMeta } from "/src/packages/manage-talents/pages/p/active-sourcing/releases/index.vue?macro=true";
import { default as indexdMpsuiQxOvYDr1gSezk13_O0W_45cBb69_45QJNkeBcI820Meta } from "/src/packages/manage-talents/pages/p/active-sourcing/saved-search/index.vue?macro=true";
import { default as _91profileId_93d9tct_45beeQapn4e2AqmwSyTCp1rAqaKFmiX_45Yram578Meta } from "/src/packages/manage-talents/pages/p/active-sourcing/messages/[profileId].vue?macro=true";
import { default as indexFbh0FfcmBDkGMIzyZ1mVl48AW6OfrJdk5bERKBQP4M0Meta } from "/src/packages/manage-talents/pages/p/active-sourcing/info-new-version/index.vue?macro=true";
import { default as index9JjKy5w6A7XPyW9oO1lju3kj7Mxlz6z51zrZ2NIcsMsMeta } from "/src/packages/manage-talents/pages/p/active-sourcing/matching/[jobId]/index.vue?macro=true";
import { default as indexSDziwwXyYcpt3beWRfCefL2KPVbWE_45AVnFqh0UJ08IQMeta } from "/src/packages/manage-talents/pages/p/active-sourcing/projects/[projectId]/index.vue?macro=true";
import { default as _91profileId_93GrShCJ8lQKC70VQzNn3MEldplRJvKyJDA3UzMY_45rACUMeta } from "/src/packages/manage-talents/pages/p/active-sourcing/search/contact/[profileId].vue?macro=true";
import { default as _91profileId_93BLLQxr1OgLGAf4nOFmMgv3ImNtF9gerF_ylfkQp11c4Meta } from "/src/packages/manage-talents/pages/p/active-sourcing/search/candidate/[profileId].vue?macro=true";
import { default as _91profileId_93oAdqO_7lruuI6AYoVdfcA8xMgIKyADT4l2bRKK_45ILB8Meta } from "/src/packages/manage-talents/pages/p/active-sourcing/matching/[jobId]/contact/[profileId].vue?macro=true";
import { default as _91profileId_93o2I20Jo_45v_Q8cLVt2FIhuF4dRm3sqJuBQc37rxiLSdsMeta } from "/src/packages/manage-talents/pages/p/active-sourcing/projects/[projectId]/contact/[profileId].vue?macro=true";
import { default as active_45sourcing2ydCbovBu4yhinWQ6AZe5WLDVWx5clv9F2jHqH9ELdQMeta } from "/src/packages/manage-talents/pages/p/active-sourcing.vue?macro=true";
import { default as inputs6d81ccI_TzY044F7U83V_8DdnznobZXQbonoWOxyyVEMeta } from "/src/packages/base/pages/styleguide/inputs.vue?macro=true";
import { default as selectNtWJ83Mn9xdP_k5fBDaFJaYIWHOl3e0riJso2rbzrUEMeta } from "/src/packages/base/pages/styleguide/select.vue?macro=true";
import { default as designuBC6hxoNAdtakC77j8gREG9GIfZeKRt594k_45vSRCYMgMeta } from "/src/packages/manage-job-ads/pages/p/jobs/[id]/design.vue?macro=true";
import { default as infoboxF6RhnzezBuLVT9TXBPtK8rmwrzq4Hhq5xyXNYnE8tNYMeta } from "/src/packages/base/pages/styleguide/infobox.vue?macro=true";
import { default as stepper7Bpf2hQrs8RC9yR508AY1N_45wQaF_45Yf_g_cWdF0QP7ZAMeta } from "/src/packages/base/pages/styleguide/stepper.vue?macro=true";
import { default as indexM2t7SBSmGfs3FivzrrtaofA_455kROoDivTxmcwv0fwu0Meta } from "/src/packages/manage-job-ads/pages/p/internal/qa/index.vue?macro=true";
import { default as contentqsC7fsats6v_z4gbMSakD9tPzWuMBkLs4X57jjiAi9oMeta } from "/src/packages/manage-job-ads/pages/p/jobs/[id]/content.vue?macro=true";
import { default as productBSTCbcJtuYRUwNbgz23q0pNE4Y4EIlnXieES5Vsj6xEMeta } from "/src/packages/manage-job-ads/pages/p/jobs/[id]/product.vue?macro=true";
import { default as publishtybaAY68xZLdUyLvOSLP0cJ5zX39xubLk60syDCQD90Meta } from "/src/packages/manage-job-ads/pages/p/jobs/[id]/publish.vue?macro=true";
import { default as summary55YyJormCaoeNIdFYptW6vJexZFXV72dZ8J7OO16eN8Meta } from "/src/packages/manage-job-ads/pages/p/jobs/[id]/summary.vue?macro=true";
import { default as controls49ILAnDrqEhAzGjTYqrg3RquwWUVHgcU8298rX5oeOgMeta } from "/src/packages/base/pages/styleguide/controls.vue?macro=true";
import { default as wrappers2Re5lCrJJ5GhkYlEZ9636VRUG_45JlxMrwyoXb_cwTr7oMeta } from "/src/packages/base/pages/styleguide/wrappers.vue?macro=true";
import { default as file_45uploadHyjU_45YAmFVPnDIKp2U8If9WPEXds0OfR9b2CjKRiCUsMeta } from "/src/packages/base/pages/styleguide/file-upload.vue?macro=true";
import { default as progressbarMJeTkLm42_57G_iCpz2ob_n_pTMn14Dw1KhkGpfgbsQMeta } from "/src/packages/base/pages/styleguide/progressbar.vue?macro=true";
import { default as indexVBHp9aIMbLjsGlFsVvKome5OC8gp9x9leR5STGXzpjQMeta } from "/src/packages/commerce/pages/kh/offene-stellen/index.vue?macro=true";
import { default as indexQDn2A4c5n6TCnj4ScfguSoyZIZGiM3pF6yzkEvd4Qp8Meta } from "/src/packages/commerce/pages/kh/recruiting-mix/index.vue?macro=true";
import { default as applicationCMTrHbyWd95v_blcaOqNSpL18bT5ADiLPIEajOKes_wMeta } from "/src/packages/manage-job-ads/pages/p/jobs/[id]/application.vue?macro=true";
import { default as notification4QzkQ6TAHnzNqPx7XUoJkZqw5Au1EHAoHcyDrhWuGE4Meta } from "/src/packages/base/pages/styleguide/notification.vue?macro=true";
import { default as indexj_45GR2TDxX8p_45GpXscwjka6a1IsngY_45jlTj_4jK_45Ll_45UMeta } from "/src/packages/manage-job-ads/pages/p/internal/qa/[id]/index.vue?macro=true";
import { default as reportRJoiX8OQe8YGv1YUdH6SaxZfzpOYw1GV_45CHpGMSioSEMeta } from "/src/packages/manage-job-ads/pages/p/internal/qa/[id]/report.vue?macro=true";
import { default as _91id_93iEHo_656RwjC84oCD8sOV3rAoO6_EgCYgGv2_45sbq1ugMeta } from "/src/packages/commerce/pages/produkte/talentsuche/[id].vue?macro=true";
import { default as index3uPAHTa_IHpKsC3HPr7x3pXMGtsLKgchTcVtfDnlFnUMeta } from "/src/packages/commerce/pages/produkte/talentsuche/index.vue?macro=true";
import { default as _91id_93_DxlnHX4j9IPXdIQ5jh2ct_454Na5MNV7V1c9HydsB2yEMeta } from "/src/packages/commerce/pages/produkte/stelleninserate/[id].vue?macro=true";
import { default as indexCMnnvzCxOfbn9itj2mYm_p26ZGhEo6H_45HsBaiYq2ByEMeta } from "/src/packages/commerce/pages/produkte/stelleninserate/index.vue?macro=true";
import { default as indexkpprEagRhMmhNOphRbFnbniLzrymqDxlG9_V43jkUToMeta } from "/src/packages/commerce/pages/produkte/arbeitgebermarke/index.vue?macro=true";
import { default as indexGUUTBMatn8lg6nqPEKvh_45x7CtzeNva7Uh4C03pA1khwMeta } from "/src/packages/commerce/pages/kh/richtigen-talente-anziehen/index.vue?macro=true";
import { default as indexm9FsT8mQT60HZvSncB_pr31ipB3uqGFLjejeIlydn_45MMeta } from "/src/packages/employer-branding/pages/p/employer-branding/dashboard/index.vue?macro=true";
import { default as indexIsH0f4WlqJLs3Gb_45LJ1VO0ipjj39_45NpJwlE2qfaL3hwMeta } from "/src/packages/manage-job-ads/pages/p/internal/companies/[companyId]/jobs/index.vue?macro=true";
import { default as createCqWoU0jRqv6IkPXXQwQmVYPOYy_EtU5GAecPfGhInjMMeta } from "/src/packages/manage-job-ads/pages/p/internal/companies/[companyId]/jobs/create.vue?macro=true";
import { default as index_1ooPJBlKfNC__sSh7W3oOZ7lt_javXSCmDJzOx2u80Meta } from "/src/packages/manage-job-ads/pages/p/internal/companies/[companyId]/jobs/[id]/index.vue?macro=true";
export default [
  {
    name: "debug",
    path: "/debug",
    meta: debug2MH7X4CfQRx1h_45ta1ByuPeCmzWA8eiYHBWQGpxbKRL8Meta || {},
    component: () => import("/src/pages/debug.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexL2_4506P0VKVzlQLJwGht__tlSHUjvBBZYAsDJVWgdCGIMeta || {}), ...{"middleware":["maintenance"]} },
    component: () => import("/src/packages/commerce/pages/index.vue")
  },
  {
    name: "p",
    path: "/p",
    component: () => import("/src/pages/p/index.vue")
  },
  {
    name: "wartung",
    path: "/wartung",
    meta: wartungfMwduimPPGp50NC2aGowLppV3eJw81Ydo9B3olbgNVsMeta || {},
    component: () => import("/src/pages/wartung.vue")
  },
  {
    name: "p-jobs",
    path: "/p/jobs",
    meta: indexJl1Ft0yZCanmCN8pZVI8mPovWSGnz9kFwGfaeyzthFEMeta || {},
    component: () => import("/src/packages/manage-job-ads/pages/p/jobs/index.vue")
  },
  {
    name: "p-jobs-create",
    path: "/p/jobs/create",
    meta: createNe4jlXPQawOgHQAz0ktoMzkSr5rzhmW_45x8p4SwA4iLAMeta || {},
    component: () => import("/src/packages/manage-job-ads/pages/p/jobs/create.vue")
  },
  {
    name: "smart-bewerben",
    path: "/smart-bewerben",
    meta: smart_45bewerbenw_K19F2MTfsc6viFKM95kVeX3oMuaUivEOyLtL7LLREMeta || {},
    component: () => import("/src/packages/commerce/pages/smart-bewerben.vue")
  },
  {
    name: "styleguide-link",
    path: "/styleguide/link",
    meta: linkBWj1BywM3RTeTTUG6x_45GYmsTQh1e4bgcdkBkpCQWOo4Meta || {},
    component: () => import("/src/packages/base/pages/styleguide/link.vue")
  },
  {
    name: "styleguide-pill",
    path: "/styleguide/pill",
    meta: pillL_TRW_Z2_45hM_rk4JUN8B73rGK70Z4YyZa9hxkzFMcG0Meta || {},
    component: () => import("/src/packages/base/pages/styleguide/pill.vue")
  },
  {
    name: "styleguide-tabs",
    path: "/styleguide/tabs",
    meta: tabsJM1NrDc5e7wqd5MaCk2HmIWJ4qOOUjvp4phL3O2WlMwMeta || {},
    component: () => import("/src/packages/base/pages/styleguide/tabs.vue")
  },
  {
    name: "bewerber-manager",
    path: "/bewerber-manager",
    meta: bewerber_45manageroMaMQKykdRAtHV5TgyY9wBWU572YiOuVu1Hlwo4HVgQMeta || {},
    component: () => import("/src/packages/commerce/pages/bewerber-manager.vue")
  },
  {
    name: "p-internal",
    path: "/p/internal",
    meta: indexLlCzd8rU7RMn7qG3MtPhJ9jCiQyjQ2sBqiC37gQRjfsMeta || {},
    component: () => import("/src/packages/manage-job-ads/pages/p/internal/index.vue")
  },
  {
    name: "p-internal-login",
    path: "/p/internal/login",
    meta: login0TsUJJE1oGh8vVkt7wPELZPYfAq2HPTAvM2SS0SfyfoMeta || {},
    component: () => import("/src/packages/manage-job-ads/pages/p/internal/login.vue")
  },
  {
    name: "p-jobs-id-data",
    path: "/p/jobs/:id()/data",
    meta: { ...(dataFpSoOm858ehsByck4V4dcnf_dH1DopEiNSv5_CMBqAgMeta || {}), ...{"middleware":["jam-form-step"]} },
    component: () => import("/src/packages/manage-job-ads/pages/p/jobs/[id]/data.vue")
  },
  {
    name: "styleguide-group",
    path: "/styleguide/group",
    meta: groupTiOhuOFLkqlAVtvyQ4FWN_yp4ge64mGd48a3Comb0ZgMeta || {},
    component: () => import("/src/packages/base/pages/styleguide/group.vue")
  },
  {
    name: "styleguide",
    path: "/styleguide",
    meta: index4lsU2BrKCyQvJJL6VgbRSlgeoyUJIyStpZairOQ9fCoMeta || {},
    component: () => import("/src/packages/base/pages/styleguide/index.vue")
  },
  {
    name: "styleguide-modal",
    path: "/styleguide/modal",
    meta: modalAgh5ioxmfmDqcNq8eJO51WRzA3G4JIhmrrKs7rb6YT4Meta || {},
    component: () => import("/src/packages/base/pages/styleguide/modal.vue")
  },
  {
    name: "styleguide-table",
    path: "/styleguide/table",
    meta: tableR_lukLHoWFxZNjg0H2Hg0HwDBFU95BQLRsg4dkUa6J4Meta || {},
    component: () => import("/src/packages/base/pages/styleguide/table.vue")
  },
  {
    name: "p-active-sourcing",
    path: "/p/active-sourcing",
    meta: active_45sourcing2ydCbovBu4yhinWQ6AZe5WLDVWx5clv9F2jHqH9ELdQMeta || {},
    component: () => import("/src/packages/manage-talents/pages/p/active-sourcing.vue"),
    children: [
  {
    name: "p-active-sourcing-search",
    path: "search",
    meta: indexGqBNXcbUksxiJB_45T1I355fZbES18WjhFZbvFRqSLpYcMeta || {},
    component: () => import("/src/packages/manage-talents/pages/p/active-sourcing/search/index.vue")
  },
  {
    name: "p-active-sourcing-matching",
    path: "matching",
    component: () => import("/src/packages/manage-talents/pages/p/active-sourcing/matching/index.vue")
  },
  {
    name: "p-active-sourcing-messages",
    path: "messages",
    meta: index8GaCZgXZ_S3o1AOf2brXTcIt0wnDLj43lIOE7hgFuCYMeta || {},
    component: () => import("/src/packages/manage-talents/pages/p/active-sourcing/messages/index.vue")
  },
  {
    name: "p-active-sourcing-projects",
    path: "projects",
    component: () => import("/src/packages/manage-talents/pages/p/active-sourcing/projects/index.vue")
  },
  {
    name: "p-active-sourcing-releases",
    path: "releases",
    component: () => import("/src/packages/manage-talents/pages/p/active-sourcing/releases/index.vue")
  },
  {
    name: "p-active-sourcing-saved-search",
    path: "saved-search",
    component: () => import("/src/packages/manage-talents/pages/p/active-sourcing/saved-search/index.vue")
  },
  {
    name: "p-active-sourcing-messages-profileId",
    path: "messages/:profileId()",
    component: () => import("/src/packages/manage-talents/pages/p/active-sourcing/messages/[profileId].vue")
  },
  {
    name: "p-active-sourcing-info-new-version",
    path: "info-new-version",
    meta: indexFbh0FfcmBDkGMIzyZ1mVl48AW6OfrJdk5bERKBQP4M0Meta || {},
    component: () => import("/src/packages/manage-talents/pages/p/active-sourcing/info-new-version/index.vue")
  },
  {
    name: "p-active-sourcing-matching-jobId",
    path: "matching/:jobId()",
    component: () => import("/src/packages/manage-talents/pages/p/active-sourcing/matching/[jobId]/index.vue")
  },
  {
    name: "p-active-sourcing-projects-projectId",
    path: "projects/:projectId()",
    component: () => import("/src/packages/manage-talents/pages/p/active-sourcing/projects/[projectId]/index.vue")
  },
  {
    name: "p-active-sourcing-search-contact-profileId",
    path: "search/contact/:profileId()",
    component: () => import("/src/packages/manage-talents/pages/p/active-sourcing/search/contact/[profileId].vue")
  },
  {
    name: "p-active-sourcing-search-candidate-profileId",
    path: "search/candidate/:profileId()",
    meta: _91profileId_93BLLQxr1OgLGAf4nOFmMgv3ImNtF9gerF_ylfkQp11c4Meta || {},
    component: () => import("/src/packages/manage-talents/pages/p/active-sourcing/search/candidate/[profileId].vue")
  },
  {
    name: "p-active-sourcing-matching-jobId-contact-profileId",
    path: "matching/:jobId()/contact/:profileId()",
    component: () => import("/src/packages/manage-talents/pages/p/active-sourcing/matching/[jobId]/contact/[profileId].vue")
  },
  {
    name: "p-active-sourcing-projects-projectId-contact-profileId",
    path: "projects/:projectId()/contact/:profileId()",
    component: () => import("/src/packages/manage-talents/pages/p/active-sourcing/projects/[projectId]/contact/[profileId].vue")
  }
]
  },
  {
    name: "styleguide-inputs",
    path: "/styleguide/inputs",
    meta: inputs6d81ccI_TzY044F7U83V_8DdnznobZXQbonoWOxyyVEMeta || {},
    component: () => import("/src/packages/base/pages/styleguide/inputs.vue")
  },
  {
    name: "styleguide-select",
    path: "/styleguide/select",
    meta: selectNtWJ83Mn9xdP_k5fBDaFJaYIWHOl3e0riJso2rbzrUEMeta || {},
    component: () => import("/src/packages/base/pages/styleguide/select.vue")
  },
  {
    name: "p-jobs-id-design",
    path: "/p/jobs/:id()/design",
    meta: { ...(designuBC6hxoNAdtakC77j8gREG9GIfZeKRt594k_45vSRCYMgMeta || {}), ...{"middleware":["jam-form-step"]} },
    component: () => import("/src/packages/manage-job-ads/pages/p/jobs/[id]/design.vue")
  },
  {
    name: "styleguide-infobox",
    path: "/styleguide/infobox",
    meta: infoboxF6RhnzezBuLVT9TXBPtK8rmwrzq4Hhq5xyXNYnE8tNYMeta || {},
    component: () => import("/src/packages/base/pages/styleguide/infobox.vue")
  },
  {
    name: "styleguide-stepper",
    path: "/styleguide/stepper",
    meta: stepper7Bpf2hQrs8RC9yR508AY1N_45wQaF_45Yf_g_cWdF0QP7ZAMeta || {},
    component: () => import("/src/packages/base/pages/styleguide/stepper.vue")
  },
  {
    name: "p-internal-qa",
    path: "/p/internal/qa",
    meta: indexM2t7SBSmGfs3FivzrrtaofA_455kROoDivTxmcwv0fwu0Meta || {},
    component: () => import("/src/packages/manage-job-ads/pages/p/internal/qa/index.vue")
  },
  {
    name: "p-jobs-id-content",
    path: "/p/jobs/:id()/content",
    meta: { ...(contentqsC7fsats6v_z4gbMSakD9tPzWuMBkLs4X57jjiAi9oMeta || {}), ...{"middleware":["jam-form-step"]} },
    component: () => import("/src/packages/manage-job-ads/pages/p/jobs/[id]/content.vue")
  },
  {
    name: "p-jobs-id-product",
    path: "/p/jobs/:id()/product",
    meta: { ...(productBSTCbcJtuYRUwNbgz23q0pNE4Y4EIlnXieES5Vsj6xEMeta || {}), ...{"middleware":["jam-form-step"]} },
    component: () => import("/src/packages/manage-job-ads/pages/p/jobs/[id]/product.vue")
  },
  {
    name: "p-jobs-id-publish",
    path: "/p/jobs/:id()/publish",
    meta: { ...(publishtybaAY68xZLdUyLvOSLP0cJ5zX39xubLk60syDCQD90Meta || {}), ...{"middleware":["jam-form-step"]} },
    component: () => import("/src/packages/manage-job-ads/pages/p/jobs/[id]/publish.vue")
  },
  {
    name: "p-jobs-id-summary",
    path: "/p/jobs/:id()/summary",
    meta: summary55YyJormCaoeNIdFYptW6vJexZFXV72dZ8J7OO16eN8Meta || {},
    component: () => import("/src/packages/manage-job-ads/pages/p/jobs/[id]/summary.vue")
  },
  {
    name: "styleguide-controls",
    path: "/styleguide/controls",
    meta: controls49ILAnDrqEhAzGjTYqrg3RquwWUVHgcU8298rX5oeOgMeta || {},
    component: () => import("/src/packages/base/pages/styleguide/controls.vue")
  },
  {
    name: "styleguide-wrappers",
    path: "/styleguide/wrappers",
    meta: wrappers2Re5lCrJJ5GhkYlEZ9636VRUG_45JlxMrwyoXb_cwTr7oMeta || {},
    component: () => import("/src/packages/base/pages/styleguide/wrappers.vue")
  },
  {
    name: "styleguide-file-upload",
    path: "/styleguide/file-upload",
    meta: file_45uploadHyjU_45YAmFVPnDIKp2U8If9WPEXds0OfR9b2CjKRiCUsMeta || {},
    component: () => import("/src/packages/base/pages/styleguide/file-upload.vue")
  },
  {
    name: "styleguide-progressbar",
    path: "/styleguide/progressbar",
    meta: progressbarMJeTkLm42_57G_iCpz2ob_n_pTMn14Dw1KhkGpfgbsQMeta || {},
    component: () => import("/src/packages/base/pages/styleguide/progressbar.vue")
  },
  {
    name: "kh-offene-stellen",
    path: "/kh/offene-stellen",
    meta: indexVBHp9aIMbLjsGlFsVvKome5OC8gp9x9leR5STGXzpjQMeta || {},
    component: () => import("/src/packages/commerce/pages/kh/offene-stellen/index.vue")
  },
  {
    name: "kh-recruiting-mix",
    path: "/kh/recruiting-mix",
    meta: indexQDn2A4c5n6TCnj4ScfguSoyZIZGiM3pF6yzkEvd4Qp8Meta || {},
    component: () => import("/src/packages/commerce/pages/kh/recruiting-mix/index.vue")
  },
  {
    name: "p-jobs-id-application",
    path: "/p/jobs/:id()/application",
    meta: { ...(applicationCMTrHbyWd95v_blcaOqNSpL18bT5ADiLPIEajOKes_wMeta || {}), ...{"middleware":["jam-form-step"]} },
    component: () => import("/src/packages/manage-job-ads/pages/p/jobs/[id]/application.vue")
  },
  {
    name: "styleguide-notification",
    path: "/styleguide/notification",
    meta: notification4QzkQ6TAHnzNqPx7XUoJkZqw5Au1EHAoHcyDrhWuGE4Meta || {},
    component: () => import("/src/packages/base/pages/styleguide/notification.vue")
  },
  {
    name: "p-internal-qa-id",
    path: "/p/internal/qa/:id()",
    meta: indexj_45GR2TDxX8p_45GpXscwjka6a1IsngY_45jlTj_4jK_45Ll_45UMeta || {},
    component: () => import("/src/packages/manage-job-ads/pages/p/internal/qa/[id]/index.vue")
  },
  {
    name: "p-internal-qa-id-report",
    path: "/p/internal/qa/:id()/report",
    meta: reportRJoiX8OQe8YGv1YUdH6SaxZfzpOYw1GV_45CHpGMSioSEMeta || {},
    component: () => import("/src/packages/manage-job-ads/pages/p/internal/qa/[id]/report.vue")
  },
  {
    name: "produkte-talentsuche-id",
    path: "/produkte/talentsuche/:id()",
    meta: { ...(_91id_93iEHo_656RwjC84oCD8sOV3rAoO6_EgCYgGv2_45sbq1ugMeta || {}), ...{"middleware":["maintenance"]} },
    component: () => import("/src/packages/commerce/pages/produkte/talentsuche/[id].vue")
  },
  {
    name: "produkte-talentsuche",
    path: "/produkte/talentsuche",
    meta: { ...(index3uPAHTa_IHpKsC3HPr7x3pXMGtsLKgchTcVtfDnlFnUMeta || {}), ...{"middleware":["maintenance"]} },
    component: () => import("/src/packages/commerce/pages/produkte/talentsuche/index.vue")
  },
  {
    name: "produkte-stelleninserate-id",
    path: "/produkte/stelleninserate/:id()",
    meta: { ...(_91id_93_DxlnHX4j9IPXdIQ5jh2ct_454Na5MNV7V1c9HydsB2yEMeta || {}), ...{"middleware":["maintenance"]} },
    component: () => import("/src/packages/commerce/pages/produkte/stelleninserate/[id].vue")
  },
  {
    name: "produkte-stelleninserate",
    path: "/produkte/stelleninserate",
    meta: { ...(indexCMnnvzCxOfbn9itj2mYm_p26ZGhEo6H_45HsBaiYq2ByEMeta || {}), ...{"middleware":["maintenance"]} },
    component: () => import("/src/packages/commerce/pages/produkte/stelleninserate/index.vue")
  },
  {
    name: "produkte-arbeitgebermarke",
    path: "/produkte/arbeitgebermarke",
    meta: indexkpprEagRhMmhNOphRbFnbniLzrymqDxlG9_V43jkUToMeta || {},
    component: () => import("/src/packages/commerce/pages/produkte/arbeitgebermarke/index.vue")
  },
  {
    name: "kh-richtigen-talente-anziehen",
    path: "/kh/richtigen-talente-anziehen",
    meta: indexGUUTBMatn8lg6nqPEKvh_45x7CtzeNva7Uh4C03pA1khwMeta || {},
    component: () => import("/src/packages/commerce/pages/kh/richtigen-talente-anziehen/index.vue")
  },
  {
    name: "p-employer-branding-dashboard",
    path: "/p/employer-branding/dashboard",
    component: () => import("/src/packages/employer-branding/pages/p/employer-branding/dashboard/index.vue")
  },
  {
    name: "p-internal-companies-companyId-jobs",
    path: "/p/internal/companies/:companyId()/jobs",
    meta: indexIsH0f4WlqJLs3Gb_45LJ1VO0ipjj39_45NpJwlE2qfaL3hwMeta || {},
    component: () => import("/src/packages/manage-job-ads/pages/p/internal/companies/[companyId]/jobs/index.vue")
  },
  {
    name: "p-internal-companies-companyId-jobs-create",
    path: "/p/internal/companies/:companyId()/jobs/create",
    meta: createCqWoU0jRqv6IkPXXQwQmVYPOYy_EtU5GAecPfGhInjMMeta || {},
    component: () => import("/src/packages/manage-job-ads/pages/p/internal/companies/[companyId]/jobs/create.vue")
  },
  {
    name: "p-internal-companies-companyId-jobs-id",
    path: "/p/internal/companies/:companyId()/jobs/:id()",
    meta: index_1ooPJBlKfNC__sSh7W3oOZ7lt_javXSCmDJzOx2u80Meta || {},
    component: () => import("/src/packages/manage-job-ads/pages/p/internal/companies/[companyId]/jobs/[id]/index.vue")
  }
]